import ButtonIcon from "../common/buttonIcon";
import { debounce } from "lodash";

const InputSearch = (props: any) => {
  let placeholder = props.placeholder ?? '';

  const onChange = debounce((event: any) => {
    props.handleClick(event.target.value);
  }, 500);

  return (
    <div className="InputSearch">
      <input placeholder={placeholder} onChange={onChange} className="form-control Input" />
      <ButtonIcon icon="search" />
    </div>
  )
}

export default InputSearch;
